import { Component, Input, OnInit } from '@angular/core';

// Usage with TypeScript or ES6
import { google, outlook, office365, yahoo, ics, CalendarEvent } from 'calendar-link';
import MobileOs from '../../enums/mobile-os';
import getMobileOS from '../../functions/getMobileOS';

@Component({
  selector: 'app-add-to-calendars',
  templateUrl: './add-to-calendars.component.html',
  styleUrls: ['./add-to-calendars.component.css'],
})
export class AddToCalendarsComponent implements OnInit {
  public actionImg = '';
  public calendarUrl = ''

  @Input()
  public event!: CalendarEvent;

  constructor() {}

  ngOnInit(): void {
    const os = getMobileOS();

    if (os === MobileOs.Android) {
      this.actionImg = 'assets/img/gcalendar.png';
      this.calendarUrl = google(this.event)
    } else {
      this.actionImg = 'assets/img/calendar.png';
      this.calendarUrl = ics(this.event)
    }
  }
}
